<template>
  <v-application>
    <v-layout class="ma-2">
      <v-flex v-bind:md6="!large" v-bind:md8="large">
        <v-card class="mb-3">
          <v-toolbar flat dense>
            <v-btn small text v-on:click="backClicked">
              <v-icon>mdi-chevron-left</v-icon>
              {{ $t("purchase_employee") }}
            </v-btn>

            <v-spacer />
            <v-btn
              class="mr-2"
              v-if="is_transfer"
              elevation="2"
              color="primary"
              @click="TransferSee()"
            >
              {{ $t("transfer") }}
            </v-btn>
            <v-btn
              class="mr-2"
              v-if="is_acespt_disabled"
              elevation="2"
              color="primary"
              @click="UpdateSee()"
            >
              {{ $t("edit") }}
            </v-btn>
            <v-menu v-bind:close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" small v-bind:icon="mobile">
                  <template v-if="!mobile">{{ $t("more") }}</template>
                  <v-icon>{{
                    mobile ? "mdi-dots-vertical" : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-on:click="downloadPdf">
                  <v-list-item-content>
                    <v-list-item-title> Save as PDF </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-on:click="downloadXls">
                  <v-list-item-content>
                    <v-list-item-title> Save as XLS </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-divider />
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">{{
                data.p_order
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ $t(data.status) }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action style="width: 150px">
              <v-progress-linear
                :color="
                  data.accept_items_count == data.items_count
                    ? 'rgb(140,199,72)'
                    : 'rgba(0,0,0,0.26)'
                "
                background-color="white"
                height="10"
                style="border: 1px solid rgba(0, 0, 0, 0.26); margin-top: 10px"
                v-bind:value="
                  (data.accept_items_count / data.items_count) * 100
                "
                striped
              />
              <v-list-item-action-text
                >{{ $t("accept") }} {{ data.accept_items_count }} of
                {{ data.items_count }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <span class="subtitle-2">{{ $t("date") }}:</span>
              <span class="body-2">{{
                new Date(data.date).toDateString()
              }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="subtitle-2">{{ $t("accept_by") }}:</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2">{{ data.accept_by_name }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="subtitle-2">{{ $t("employee") }}:</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2">{{ data.employee_name }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title>
                <span class="subtitle-2">{{ $t("store") }}:</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2">{{ data.service_name }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="subtitle-2">{{ $t("comment") }}:</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2">{{ data.note }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-toolbar flat>
            <v-toolbar-title>{{ $t("items") }}</v-toolbar-title>
          </v-toolbar>

          <v-data-table
            v-bind:headers="headers"
            v-bind:items="data_items"
            hide-default-footer
            disable-sort
            :items-per-page="200000"
            :mobile-breakpoint="0"
            @click:row="RowClick"
          >
            <template
              #[`header.is_accept`]
              v-if="!disabled || !create_transfer_disabled"
            >
              <v-simple-checkbox
                :indeterminate="earchSelect"
                v-model="allSelect"
              >
              </v-simple-checkbox>
            </template>
            <template #[`item.name`]="{ item }">
              <v-list-item-content>
                <p style="max-width: 700px">
                  {{ item.product_name }}
                </p>
                <v-list-item-subtitle
                  >SKU {{ item.product_sku }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  v-if="item.barcode && item.barcode.length > 0"
                >
                  Barcode
                  <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                    barcode + ", "
                  }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template #[`item.cost`]="{ item }"
              >{{
                typeof item.cost === typeof 5
                  ? item.cost_currency === "usd"
                    ? item.cost.toLocaleString()
                    : Math.round(item.cost).toLocaleString()
                  : item.cost
              }}{{ item.cost_currency === "usd" ? " $" : "" }}</template
            >
            <template #[`item.is_accept`]="{ item }">
              <v-simple-checkbox v-model="item.is_accept" />
            </template>
            <template #footer>
              <v-divider />
              <v-row class="ma-2 pb-2" align="center" justify="center">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!create_transfer_disabled"
                  :loading="loading"
                  color="primary"
                  @click="CreateTransfer()"
                >
                  {{ $t("create_transfer") }}
                </v-btn>
                <v-btn
                  v-if="!disabled"
                  :loading="loading"
                  color="primary"
                  @click="UpdateStatus()"
                >
                  {{ $t("update") }}
                </v-btn>
              </v-row>
            </template>
          </v-data-table>
          <v-dialog v-model="internal_dialog" persistent width="700">
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t("supplier") }}</span>
              </v-card-title>
              <v-data-table
                :headers="supp_headers"
                :items="supp_items"
                hide-default-footer
              >
              </v-data-table>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="cancelPatitionClicked" color="primary"
                  >cancel</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
export default {
  mixins: [Suppliers],
  props: {
    large: Boolean,
  },
  data: () => ({
    accept_total: 0,
    is_accepted: 0,
    receive_dialog: false,
    service_id: "",
    allSelect: false,
    earchSelect: false,
    is_acespt_disabled: false,
    is_transfer: true,
    supp_items: [],
    data_items: [],
    loading: false,
    disabled: true,
    create_transfer_disabled: true,
    internal_dialog: false,
    selected: [],
    data: {
      date: 1,
      accept_items_count: 0,
      items_count: 0,
      p_order: "",
      status: "",
      employee_name: "",
      service_name: "",
      accept_by_name: "",
      note: "",
    },
    pdfLink: "",
  }),
  methods: {
    cancelPatitionClicked() {
      this.internal_dialog = false;
    },
    async RowClick(item) {
      this.internal_dialog = true;
      const inernal = this.$communicator.then(
        this,
        await this.$communicator("partition_item_supplier", {
          arguments: [this.service_id, item.product_id],
        })
      );
      this.supp_items = inernal?.data;
    },
    async internalOrders() {
      const link = `employee/orders/${this.$route.query["id"]}`;
      const res = await this.$communicator.getMethodWithAuth(
        link,
        "2.0.0",
        "admin"
      );
      if (res == null) {
        this.data_items = [];
        this.data = {};
      }
      this.data_items = res?.data?.data?.items;
      this.data = res?.data?.data;
      this.service_id = res?.data?.data?.service_id;
      if (this.data.items_count != this.data.accept_items_count) {
        this.is_acespt_disabled = true;
      } else {
        this.is_acespt_disabled = false;
      }
    },
    async UpdateSee() {
      this.disabled = false;
      this.is_acespt_disabled = false;
      this.create_transfer_disabled = true;
      this.is_transfer = true;
    },
    TransferSee() {
      this.create_transfer_disabled = false;
      this.is_transfer = false;
      this.disabled = true;
      if (this.data.items_count != this.data.accept_items_count) {
        this.is_acespt_disabled = true;
      }
    },
    async UpdateStatus() {
      this.loading = true;
      await this.$communicator.then(
        this,
        await this.$communicator("inv_pur_employee_update", {
          arguments: [this.$route.query["id"]],
          params: {
            items: this.data_items,
          },
        })
      );
      this.$toast.success("Success", { timeout: 2000 });
      await setTimeout(() => (this.loading = false), 1000);
      this.internalOrders();
      this.$router.go(-1);
    },
    async CreateTransfer() {
      const items = [];
      for (let i = 0; i < this.data_items.length; i++) {
        if (this.data_items[i].is_accept) {
          items.push({
            product_id: this.data_items[i].product_id,
            product_name: this.data_items[i].product_name,
            quality: this.data_items[i].order_quantity,
            sku: this.data_items[i].product_sku,
          });
        }
      }
      this.$router.push({
        path: "/inventory/transfer/create",
        query: { itemsX: JSON.stringify(items), service_id: this.service_id },
      });
    },
    downloadPdf() {
      const link = `internal/order/pdf/${this.$route.query["id"]}/${this.data.p_order}.pdf`;
      this.$communicator.downloadDocument(link, `${this.data.p_order}.pdf`);
    },
    downloadXls() {
      const link = `internal/order/pdf/${this.$route.query["id"]}/${this.data.p_order}?type=exel`;
      this.$communicator.downloadDocument(
        link,
        `${this.data.p_order}?type=exel.xls`
      );
    },
    backClicked() {
      this.$router.go(-1);
    },
  },
  mounted() {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.internalOrders();
  },
  computed: {
    headers() {
      let headers = [
        { value: "is_accept" },
        { text: this.$t("item"), value: "name" },
        { text: this.$t("real_stock"), value: "real_stock" },
        {
          text: this.$t("in_stock"),
          value: "in_stock",
          align: "right",
        },

        { text: this.$t("quantity"), value: "order_quantity", align: "right" },
      ];
      return headers;
    },
    supp_headers() {
      let supp_headers = [
        {
          text: this.$t("supplier_name"),
          value: "supplier_name",
          sortable: false,
        },
      ];
      return supp_headers;
    },
    mobile() {
      return (
        this.$vuetify.breakpoint.name == "xs" ||
        this.$vuetify.breakpoint.name == "sm"
      );
    },
  },
  watch: {
    allSelect() {
      if (this.allSelect == true) {
        this.data_items.forEach((item) => (item.is_accept = true));
      } else {
        this.data_items.forEach((item) => (item.is_accept = false));
      }
    },
  },
};
</script>
